import React, { useEffect } from "react";
import { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { QueryContext } from "../../App";
const FindPassSuccess = () => {
  const navigate = useNavigate();
  const query = useContext(QueryContext);
  useEffect(() => {}, []);
  return (
    <div className="find-id-success-page">
      <div className="success-logo">
        <svg
          className="changedone"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="40" cy="40" r="40" fill="#F2F4F7" />
          <rect
            width="8.79561"
            height="22.3545"
            rx="3"
            transform="matrix(0.709405 -0.704801 0.709405 0.704801 19.168 40.2754)"
            fill="#2373EB"
          />
          <rect
            width="8.79561"
            height="36.113"
            rx="3"
            transform="matrix(0.709482 0.704724 -0.709482 0.704724 54.5898 24.5088)"
            fill="#2373EB"
          />
        </svg>
      </div>
      <div className="items item-none">
        <p className="info">비밀번호 변경 완료</p>
        <p className="sub-info">비밀번호 변경이 완료되었습니다.</p>
      </div>
      <button
        onClick={() => {
          const redirectItem = sessionStorage.getItem("redirectInfo");

          // React Native 웹뷰 감지
          const isReactNativeWebView =
            window.ReactNativeWebView ||
            window.navigator.userAgent.includes("ReactNativeWebView") ||
            window.navigator.userAgent.includes("wv") ||
            (window.navigator.userAgent.includes("Android") &&
              window.navigator.userAgent.includes("wv"));

          // redirect가 있으면 해당 URL로 이동 (웹뷰 유지)
          if (redirectItem && redirectItem !== "null") {
            if (
              redirectItem.startsWith("http://") ||
              redirectItem.startsWith("https://")
            ) {
              window.location.replace(redirectItem);
            } else {
              window.location.replace("http://" + redirectItem);
            }
          } else if (isReactNativeWebView) {
            // redirect가 없고 웹뷰인 경우에만 웹뷰 닫기
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "CLOSE_WEBVIEW",
                })
              );
            }
          } else {
            // 일반 브라우저에서 redirect 없으면 홈으로
            window.location.replace("http://www.superbin.co.kr");
          }
        }}
      >
        로그인하기
      </button>
    </div>
  );
};

export default FindPassSuccess;
